module.exports = __webpack_public_path__ + "img/zuijia_31.f3383bea.png";